import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Clients from '../components/Clients';
import { Domains, Certifications } from '../components/DomainsCerts';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Portfolio = () => {
  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <Hero />
      <About />
      <Skills />
      <Experience />
      <Clients />
      <Domains />
      <Certifications />
      <Contact />
      <Footer />
    </div>
  );
};

export default Portfolio;
